import { ApexOptions } from "apexcharts"
import { useMemo } from "react"
import ReactApexChart from "react-apexcharts"
import { ApexChartType } from "src/shared/config/DefaultApexOptions"
import { colorMapper } from "src/shared/enums/networkColors"
import { totalOnHoverTooltip } from "../../../chartTooltip"
import { MONTH_DAY_DATETIME } from "../../../chartDateAxis"
import { monitorApexOptions } from "../../../chartDateAxis"

function getSeriesXRange(series: ApexOptions["series"]): { min?: number; max?: number } {
  const arr = series as { data: [number, number][] }[] | undefined
  if (!arr?.length) return {}
  let min = Infinity
  let max = -Infinity
  for (const s of arr) {
    for (const [ts] of s.data) {
      if (ts < min) min = ts
      if (ts > max) max = ts
    }
  }
  return min === Infinity ? {} : { min, max }
}

export const ImpressionsByNetwork = ({ series }: ApexOptions) => {
  const impressionsByNetworkOptions = useMemo<ApexOptions>(
    () => {
      const { min, max } = getSeriesXRange(series)
      return monitorApexOptions(
        {
          colors: colorMapper(series),
          // §3.5: the day's combined total alongside the per-network breakdown.
          tooltip: { shared: true, intersect: false, custom: totalOnHoverTooltip("number") },
          xaxis: { min, max, labels: { datetimeFormatter: MONTH_DAY_DATETIME } },
        },
        ApexChartType.bar,
      )
    },
    [series],
  )

  return (
    <div>
      <ReactApexChart
        options={impressionsByNetworkOptions}
        series={series}
        type="bar"
        height={400}
      />
    </div>
  )
}
